export function partition<T>(ts: T[], cb: (t: T) => boolean): [T[], T[]] {
  const res: [T[], T[]] = [[], []];
  for (const t of ts) {
    if (cb(t)) {
      res[0].push(t);
    } else {
      res[1].push(t);
    }
  }
  return res;
}
